import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const CurrentProjectContainer = styled.div`
	width: 100%;
	background-color: ${Variables.colors.complementary_light};
	position: relative;
	box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
	margin-bottom: 5px;
	.top-row{
	  height: 42px;
	  display: flex;
	  padding: 0 16px 0 16px;
	  position: relative;
        .current-project-name {
            color: ${Variables.colors.complementary_900};
            font-size: ${Variables.font_sizes.x_medium};
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            max-width: 230px;
            span {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
        }
        .current-project-menu-icon {
            cursor: pointer;
            margin-left: 12px;
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 42px;
            &:before {
                color: ${Variables.colors.complementary_700};
                font-size: 16px;
                margin: 0;
            }
        }
	}
	.bottom-row{
	    padding: 0 16px 16px 16px;
	    width: 100%;
        display: flex;
        justify-content: center;
        .link-button{
          cursor: pointer;
          background-color: ${Variables.colors.primary_vivid};
          color: ${Variables.colors.complementary};
          border-radius: 4px;
          width: 100%;
          font-size: ${Variables.font_sizes.x2_medium};
          padding: 6px 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
	}
	// .current-project-icon {
	// 	margin-left: 12px;
	// 	position: absolute;
	// 	right: 16px;
	// 	top: 0;
	// 	display: flex;
	// 	justify-content: space-between;
	// 	align-items: center;
	// 	width: 24px;
	// 	height: 42px;
	// 	&:before {
	// 		color: ${Variables.colors.complementary};
	// 		font-size: 20px;
	// 		margin: 0;
	// 	}
	// }
	
`;
const COLORS = {
  success: {
    background: Variables.colors.green_100,
    text: Variables.colors.green_800
  },
  secondary: {
    background: Variables.colors.complementary_400,
    text: Variables.colors.complementary_700
  }
};
export const TagBox = styled.div`
  background-color: ${props =>
    props.type
      ? COLORS[props.type].background
      : COLORS["secondary"].background};
  color: ${props =>
    props.type ? COLORS[props.type].text : COLORS["secondary"].text};
  font-size: ${Variables.font_sizes.x_small};
  border-radius: 14px;
  height: 24px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  padding: 3px 9px;
  white-space: nowrap;
  font-weight: ${Variables.font_weight.medium};
`;
